import Loader from "./elements/Loader.js";

module.exports = {
  Loader: Loader
};
